(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scroll-timeline-content"] && !Shopify.designMode) return;
  try {
    class ScrollTimelineContent extends HTMLElement {
        constructor() {
            super();

            this.handleScroll = this.handleScroll.bind(this);
        }

        connectedCallback() {
            this.noHotspot = this.hasAttribute('data-no-hotspot');
            if (this.noHotspot) return;

            this.scrollProgressEl = this.querySelector('.scroll-progress');
            this.scrollCursorEl = this.querySelector('.scroll-cursor');
            this.anchorEl = document.querySelector(`a[href="#${this.id}"]`);

            this.handleScroll();
            document.addEventListener('scroll', this.handleScroll);
        }

        handleScroll() {
            this.startOffset = window.innerHeight / 2;

            this.originalProgress = (window.scrollY - this.offsetTop + this.startOffset) / this.offsetHeight;
            this.progress = Math.max(Math.min(this.originalProgress, 1), 0);

            this.scrollProgressEl.style.transform = `scaleY(${this.progress})`;
            this.scrollCursorEl.style.top = `${this.progress * 100}%`;
            this.scrollCursorEl.style.transform = `translateX(-50%) translateY(-${this.progress * 100}%)`;

            if (this.progress > 0 && this.progress < 1) {
                this.anchorEl.classList.add('active');
            } else {
                this.anchorEl.classList.remove('active');
            }
        }
    }

    if (customElements.get('w3-scroll-timeline-content') === undefined) {
        customElements.define('w3-scroll-timeline-content', ScrollTimelineContent);
    }
  } catch(e) { console.error(e); }
})();

})();
